export default __webpack_public_path__ + "static/media/300.745b0376.png";